import { SET_POS_TERMINAL_LIST } from '../types/dejavoo'
import { saveSession, getSession } from '../utils/api'

const session = getSession()

const initState = {
  session,
  posTerminals: [],
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_POS_TERMINAL_LIST:
      return { ...state, posTerminals: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/posTerminal.js